/**
 * Provides props for a modal to accept either:
 * - A single lang key to use as the modal title.
 * - A custom piece of text to use as the modal title.
 */
export const DialogTitlePropsMixin = {
    computed: {
        headerColorClass() {
            if (this.color === 'danger') {
                return 'modl--danger';
            } else if (this.color === 'warning') {
                return 'modl--warning';
            } else if (this.color === 'success') {
                return 'modl--success';
            }
            return '';
        },
    },

    props: {
        /**
         * A single lang key to use as the modal title.
         */
        title: {
            type: String,
            default: null,
        },
        /**
         * A custom piece of text to display escaped as the modal title.
         */
        customTitleText: {
            type: String,
            default: null,
        },

        icon: {
            type: String,
            default: 'fa-question-circle',
        },

        color: {
            type: String, // One of 'danger', 'warning' or 'success'
            default: '',
        },
    },
};
